import { render } from "./updateUserDataLernpfadProgressMutation.vue?vue&type=template&id=7a6e0c78"
import script from "./updateUserDataLernpfadProgressMutation.vue?vue&type=script&lang=js"
export * from "./updateUserDataLernpfadProgressMutation.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__